import React from 'react';
import c from './images/C.jpg';
import python from './images/python.png';
import java from './images/java.png';
import sql from './images/MySQL.jpg';
import html from './images/html-5.png';
import css from './images/css-3.png';
import js from './images/js.png';
import reactjs from './images/react js.jpg';
import reactnative from './images/react-native-app-icon.png';
import firebase from './images/google-firebase-icon.png'
import materialui from './images/material ui.png';
import vscode from './images/Visual Studio Code.png'
import '../styles/Skills.css'
import figma from './images/figma.png'
const lang = [
  {
    logo: reactjs,
    name: 'React js'
  },
  {
    logo: reactnative,
    name: 'React Native'
  },
  {
    logo: html,
    name: 'HTML'
  },

  {
    logo: css,
    name: 'CSS'
  },
  {
    logo: js,
    name: 'Javascript'
  },
  {
    logo: firebase,
    name: 'Firebase'
  },{
    logo: materialui,
    name: 'Material ui'
  },
  {
    logo: vscode,
    name: 'VS code'
  },
  {
    logo: c,
    name: 'C programming'
  },
  {
    logo: java,
    name: 'Java'
  },
  {
    logo: python,
    name: 'Python'
  },
  {
    logo: sql,
    name: 'MY SQL'
  },
  {
    logo: figma,
    name: 'Figma'
  }
];

const Skills = () => {
  return (
    <center>
      <center ><h1 className='m-heading'>Tools<span className='m-span'> usage</span></h1>
      <p className='p' style={{fontSize:"15px"}} >Proficient in C, Python, Java, HTML, CSS, ReactJS, and React Native, I excel in web development with tools like Node.js, VScode, and Figma, backed by expertise in Firebase and MySQL.</p>
</center>
{/* <center>
          <h1 className='h1' >Skills & Tools</h1>
          <p className='p' >Proficient in C, Python, Java, HTML, CSS, ReactJS, and React Native, I excel in web development with tools like Node.js, VScode, and Figma, backed by expertise in Firebase and MySQL.</p>
        </center> */}
    <div className='s-container'>
    
      {lang.map((item, index) => (
        <div key={index} className='s-item'>
          <img src={item.logo} alt={item.name}  className='s-name'/>
          <p className='s-para'>{item.name}</p>
        </div>
      ))}
    </div>
    </center>
  );
};

export default Skills;
